<template>
  <li class="search-result search-result-theme">
    <router-link :to="{path: linkValue}" class="search-result-name">
      {{ name }}
    </router-link>
  </li>
</template>

<script>

export default {
  data() {
    return {
      linkValue: '',
      name: ''
    }
  },
  props: {
    tagData: {
      type: Object,
      required: true
    },
  },
  created() {
    this.createData()
  },
  updated() {
    this.createData();
  },
  methods: {
    createData() {
      if(this.$props.tagData.type == 'item') {
        this.linkValue = '/tag/'+this.$props.tagData.tagId+'/place/'+this.$props.tagData.id;
      }
      else if(this.$props.tagData.type == 'tag') {
        let tag = this.$props.tagData.tagId || this.$props.tagData.tags;
        this.linkValue = '/tag/'+tag;
      }
      else if(this.$props.tagData.type == 'link') {
        this.linkValue = this.$props.tagData.link;
      }
      else {
        this.linkValue = '/'+((this.$props.tagData.realType) ? this.$props.tagData.realType : (this.$props.tagData.type) ? this.$props.tagData.type : 'tag')+'/'+this.$props.tagData.id;
      }
      this.name = (this.$props.tagData.name_plural || this.$props.tagData.title || this.$props.tagData.name);
    }
  }
}
</script>

<style lang="scss" scoped>
  .search-address-result span {
    pointer-events: none;
  }

  .search-result {
    border-bottom: 1px solid rgba(190, 190, 190, 0.5);
    line-height: 40px;
    min-height: 40px;
    vertical-align: middle;
    padding: 0px 5px;
    clear: both;
    display: inline-block;
    width: 100%;
    cursor: pointer;
  }

  .search-result:last-child {
    border: 0;
  }

  @media screen and (min-width: 767px) {
    .search-result {
      padding: 0px;
    }
  }

  .long-search-result {
    max-width: 45%;
    line-height: 23px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .long-search-result:first-child {
    max-width: 55%;
    min-height: 50px;
  }
</style>
